import { render } from "./Progetti.vue?vue&type=template&id=24dc7982&scoped=true&ts=true"
import script from "./Progetti.vue?vue&type=script&lang=ts"
export * from "./Progetti.vue?vue&type=script&lang=ts"

import "./Progetti.vue?vue&type=style&index=0&id=24dc7982&scoped=true&lang=css"

import exportComponent from "/var/www/app_server_flask/temp/temp_app_ingegno_plan_1778832654194047890/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24dc7982"]])

export default __exports__